import { defineView } from "eddev/views"
import { ContentBlocks } from "eddev/blocks"
import { useRoute } from "eddev/routing"
import { Breadcrumbs } from "@components/atoms/Breadcrumbs"
import { Col, Container, Grid } from "@components/layout/Grid"
import { useSubtheme } from "@hooks/useSubtheme"
import { useIsMobile } from "@hooks/useViewportDerived"

export const meta: ViewMeta = {
  templateName: "Home Pages",
}

export default defineView("templates/home-pages", (props) => {
  useSubtheme("offwhite")
  const route = useRoute()
  const isMobile = useIsMobile()

  return (
    <>
      {route.pathname && props.page?.pageOptions?.showBreadcrumbs && (
        <Breadcrumbs uri={route.pathname} page={props.page} />
      )}
      <ContentBlocks
        blocks={props.page?.contentBlocks}
        wrapBlock={(block, ctx) => {
          if (ctx.current.blockName.includes("core"))
            return (
              <Container>
                <Grid>
                  {!isMobile && <Col initial={12} tablet={1} laptop={2} />}
                  <Col initial={12} tablet={10} laptop={8}>
                    {block}
                  </Col>
                </Grid>
              </Container>
            )

          return <>{block}</>
        }}
      />
    </>
  )
})
